import Ajv2020 from 'ajv/dist/2020';
import type { McpTool } from './McpBridgeProvider';

// Single reusable validator. `strict: false` so Ajv reports draft-2020-12
// metaschema conformance without layering on its own strict-mode opinions;
// formats are irrelevant to structural validity, so skip them.
const ajv = new Ajv2020({ strict: false, allErrors: true, validateFormats: false });

export type InvalidToolSchema = { name: string; errors: string[] };

/**
 * Validate each advertised tool's `inputSchema` against the JSON Schema
 * draft-2020-12 metaschema. A schema the LLM providers would reject as a tool
 * declaration (see the WebMCP schema analysis) shows up here. Returns one entry
 * per invalid tool; an empty array means every schema is well-formed.
 */
export function findInvalidToolSchemas(tools: McpTool[]): InvalidToolSchema[] {
  const invalid: InvalidToolSchema[] = [];

  for (const tool of tools) {
    const schema = tool.inputSchema;
    if (!schema || typeof schema !== 'object') continue;

    const valid = ajv.validateSchema(schema) as boolean;
    if (!valid) {
      const errors = (ajv.errors ?? []).map(
        (e) => `${e.instancePath || '/'} ${e.message ?? 'invalid'}`,
      );
      invalid.push({ name: tool.name, errors });
    }
  }

  return invalid;
}
